customElements.define("new-hero-banner", class extends HTMLElement {
  connectedCallback() {
    const hero = this.querySelector("[data-hero-banner]");
    if (!hero) return;

    document.body.classList.add("hero-pinned");

    const swiperEl = this.querySelector("[data-hero-swiper]");
    if (swiperEl && this.querySelectorAll('.swiper-slide').length > 1) {
      this.initSwiper(swiperEl);
    }

    this.applySlideColors(this.getActiveSlideElement());
    this.setupStickyHeaderHandler();
    this.setupScrolledHeroHandler();

    this.addEventListener("hero-restore-header", () => {
      const header = document.querySelector(".header-wrapper");
      if (header && hero) {
        const heroRect = hero.getBoundingClientRect();
        const headerRect = header.getBoundingClientRect();
        const overlapping = headerRect.bottom > heroRect.top && headerRect.top < heroRect.bottom;
        if (overlapping) this.applySlideColors(this.getActiveSlideElement());
      }
    });
  }

  getActiveSlideElement() {
    const hero = this.querySelector("[data-hero-banner]");
    if (!hero) return null;
    if (this.swiper && this.swiper.slides && this.swiper.slides.length) {
      const realIndex = this.swiper.realIndex ?? this.swiper.activeIndex;
      const slide = this.swiper.slides[realIndex];
      return slide && slide.matches && slide.matches("[data-slide-background]") ? slide : this.swiper.slides[0];
    }
    return hero.querySelector("[data-slide-background]");
  }

  applySlideColors(slideEl) {
    if (!slideEl) return;
    const bg = (slideEl.getAttribute("data-slide-background") || "dark").toLowerCase();
    const dotsSetting = (slideEl.getAttribute("data-slide-dots-color") || "").toLowerCase();
    const isLight = bg === "light";
    const navColor = isLight ? "#000000" : "#ffffff";
    const logoClass = isLight ? "header--solid-logo" : "header--white";
    const dotsColor = dotsSetting === "black" ? "#000000" : dotsSetting === "white" ? "#ffffff" : navColor;

    document.body.classList.remove("header--white", "header--solid-logo");
    document.body.classList.add(logoClass);

    const heroEl = this.querySelector(".new-hero-banner");
    if (heroEl) {
      heroEl.style.setProperty("--hero-arrows-color", navColor);
      heroEl.style.setProperty("--hero-pagination-color", dotsColor);
    }
    document.documentElement.style.setProperty("--hero-hamburger-icon-color", navColor);
  }

  initSwiper(swiperEl) {
    const self = this;
    this.swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      loop: true,
      pagination: { el: ".swiper-pagination", clickable: true },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      autoplay: { delay: 5000, disableOnInteraction: false },
      grabCursor: true,
      effect: "fade",
      fadeEffect: { crossFade: true },
      on: {
        slideChangeTransitionEnd() {
          self.applySlideColors(self.getActiveSlideElement());
        },
      },
    });
  }

  setupStickyHeaderHandler() {
    const hero = this.querySelector("[data-hero-banner]");
    const header = document.querySelector(".header-wrapper");
    if (!header || !hero) return;
    
    const handleScroll = () => {
      const heroRect = hero.getBoundingClientRect();
      const headerRect = header.getBoundingClientRect();
      const overlapping = headerRect.bottom > heroRect.top && headerRect.top < heroRect.bottom;

      document.body.classList.remove("header--white", "header--solid-logo");
      if (overlapping) {
        this.applySlideColors(this.getActiveSlideElement());
      }
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
  }

  setupScrolledHeroHandler() {
    const hero = this.querySelector("[data-hero-banner]");
    if (!hero) return;
    
    const handleHeroScroll = () => {
      const heroRect = hero.getBoundingClientRect();
      const isHeroPassed = heroRect.bottom <= 0;
      document.body.classList.toggle("scrolled-hero", isHeroPassed);
    };

    handleHeroScroll();
    window.addEventListener("scroll", handleHeroScroll);
  }
});